module.exports = __webpack_public_path__ + "img/ic_food_bowl.ccaabb74.png";